
import {
    Box, TextField, FormControl, InputAdornment, InputLabel, Input, IconButton, Button,
    Typography, Select, MenuItem, FormHelperText, Alert, Paper
} from '@mui/material';
import { AccountCircleOutlined, Visibility, VisibilityOff, LockOutlined, Group, Label } from '@mui/icons-material';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch, } from 'react-redux';
import { set } from 'lodash';
import { Tabs } from '../../components/tabs';
import { Grid } from '../../components/table';
import { CONFIG } from '../../../config'
import axios from 'axios';
import { ToolBar } from '../../components/toolbar';
import { Modal } from '../../components/modal';
import { FormA } from '../../components/form';
import moment from 'moment';
import { getFormState } from '../../../helpers/form';
import dayjs from 'dayjs';
import {
    Chart as ChartJS, ArcElement, CategoryScale,
    LinearScale,
    BarElement,
    Title, Tooltip, Legend
} from "chart.js";
import { Doughnut, Bar } from "react-chartjs-2";
// import faker from 'faker';


ChartJS.register(ArcElement, CategoryScale,
    LinearScale,
    BarElement,
    Title, Tooltip, Legend);

export const options = {
    responsive: true,
    aspectRatio: 6,
    // maintainAspectRatio: false,
    plugins: {
        legend: {
            position: 'right',
            // align: 'start',
            // rtl: true,
            labels: {
                generateLabels: (chart) => {
                    return chart.data.labels.map((l, i) => ({
                        text: l, strokeStyle: chart.data.datasets[0].borderColor[i],
                        fillStyle: chart.data.datasets[0].backgroundColor[i]
                    }))
                },
                // textAlign: 'left'

            }
        },

        // title: {
        //     display: true,
        //     text: 'Chart.js Bar Chart',
        // },
    },
};





// import { PieChart } from '@mui/x-charts/PieChart';



const API_HOST = CONFIG.modules['accounts'].host




export const HRDashboard = (props) => {
    const { roles, user, users, Designations, Departments, Languages, Districts } = useSelector((state) => (state.user || {}))
    const userStore = useSelector((state) => (state.user || {}))

    const [active, setActive] = useState('Leave Requests')
    const [open, setOpen] = useState(false)
    const [action, setAction] = useState('new')
    const [saved, setSaved] = useState(null);
    const [index, setIndex] = useState(null);
    const [openConfirm, setOpenConfirm] = useState(false)

    const [employeeData, setEmployeeData] = useState(null)
    const [departmentData, setDepartmentData] = useState(null)
    const [divisionData, setDivisionData] = useState(null)
    const [attendanceData, setAttendanceData] = useState(null)
    const [employeesByRoles, setEmployeesByroles] = useState(null);


    const getEmployeesByRoles = () => {
        axios.get(API_HOST + `/get-dashboard-data?type=employeesByRoles`).then((resp) => {
            if (resp.data && resp.data.success) {
                setEmployeesByroles(resp.data.data)
            }
        }).catch((e) => {
            console.log(e)
        })
    }
    const getEmployeeData = () => {

        axios.get(API_HOST + `/get-dashboard-data?type=employee`).then((resp) => {
            if (resp.data && resp.data.success) {
                setEmployeeData(resp.data.data)
            }
        }).catch((e) => {
            console.log(e)
        })
    }



    const getDepartmentData = () => {

        axios.get(API_HOST + `/get-dashboard-data?type=department`).then((resp) => {
            if (resp.data && resp.data.success) {
                setDepartmentData(resp.data.data)
            }
        }).catch((e) => {
            console.log(e)
        })
    }

    const getDivisionData = () => {

        axios.get(API_HOST + `/get-dashboard-data?type=divison`).then((resp) => {
            if (resp.data && resp.data.success) {
                setDivisionData(resp.data.data)
            }
        }).catch((e) => {
            console.log(e)
        })
    }

    const getAttendanceData = () => {

        axios.get(API_HOST + `/get-dashboard-data?type=attendance`).then((resp) => {
            if (resp.data && resp.data.success) {
                setAttendanceData(resp.data.data)
            }
        }).catch((e) => {
            console.log(e)
        })
    }



    useEffect(() => {
        getEmployeeData()
        getDepartmentData()
        getDivisionData()
        getAttendanceData()
        getEmployeesByRoles()
    }, [])


    return (

        <Box sx={{ mt: 2 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Paper elevation={3} sx={{
                    display: 'flex', flexDirection: 'column',
                    height: 150,
                    width: "32%", justifyContent: 'center', alignItems: 'center'
                }}>
                    {
                        employeeData &&
                        <>
                            <Typography sx={{ color: '#EF5566', fontSize: '3em' }}>{employeeData.total || 0}</Typography>
                            <Typography sx={{ fontWeight: 500, fontSize: '1.2em' }}>Total Employees</Typography>
                        </>
                    }

                </Paper>
                <Paper elevation={3} sx={{
                    display: 'flex', flexDirection: 'column',
                    height: 150,
                    width: "32%", justifyContent: 'center', alignItems: 'center'
                }}>
                    {
                        employeeData &&
                        <>
                            <Typography sx={{ color: '#EF5566', fontSize: '3em' }}>{employeeData.totalF || 0}</Typography>
                            <Typography sx={{ fontWeight: 500, fontSize: '1.2em' }}>Full Time Employees</Typography>
                        </>
                    }
                </Paper>
                <Paper elevation={3} sx={{
                    display: 'flex', flexDirection: 'column',
                    height: 150,
                    width: "32%", justifyContent: 'center', alignItems: 'center'
                }}>
                    {
                        employeeData &&
                        <>
                            <Typography sx={{ color: '#EF5566', fontSize: '3em' }}>{employeeData.totalP || 0}</Typography>
                            <Typography sx={{ fontWeight: 500, fontSize: '1.2em' }}>Part Time Employees</Typography>
                        </>
                    }
                </Paper>
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
                <Paper elevation={3} sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    padding: 0,
                    pb: 0,
                    "-webkit-justify-content": 'flex-start',
                    height: 250,
                    overflow: 'hidden',
                    width: "32%",
                }}>

                    <Box sx={{ height: 50, background: '#955072', display: 'flex', top: 0, mt: 0, justifyContent: 'center', alignItems: 'center' }}>
                        <Typography sx={{ color: 'white' }}>Department</Typography>
                    </Box>

                    <Box sx={{
                        display: 'flex', flexDirection: 'column', justifyContent: 'center',
                        height: 200,

                        alignItems: 'center'
                    }}>
                        <Box sx={{ height: 150 }}>
                            {
                                departmentData &&
                                <Doughnut data={{
                                    labels: Object.values(departmentData.departmentMap).map(e => e.name),
                                    datasets: [
                                        {
                                            label: '# of Votes',
                                            data: Object.values(departmentData.departmentMap).map(e => e.count),
                                            backgroundColor: [
                                                '#F98027',
                                                '#5CCFB0',
                                                '#A8EA53',
                                                '#66C8EC',
                                                '#4D67CB',
                                                '#F04123',
                                                '#66C4EC',
                                                '#4E67CB',
                                                '#F08123',
                                                '#66CDEC',
                                                '#EE67CB',
                                                '#F08423',

                                            ],
                                            borderColor: 'white',
                                            borderWidth: 1,
                                        },
                                    ],
                                }} options={{
                                    responsive: true,
                                    cutout: 60,
                                    aspectRatio: 4,
                                    maintainAspectRatio: false,
                                    plugins: {
                                        legend: {
                                            position: 'right'
                                            //   display: false,
                                        },
                                    },
                                    scales: {
                                        // xAxes: [{
                                        //     barThickness: 6,  // number (pixels) or 'flex'
                                        //     maxBarThickness: 8 // number (pixels)
                                        // }]
                                    }
                                }} />
                            }

                        </Box>


                    </Box>



                </Paper>

                <Paper elevation={3} sx={{
                    display: 'flex', flexDirection: 'column', padding: 0,
                    pb: 0,
                    "-webkit-justify-content": 'flex-start',
                    height: 250,
                    overflow: 'hidden',
                    width: "32%",
                }}>
                    <Box sx={{ height: 50, background: '#955072', display: 'flex', top: 0, mt: 0, justifyContent: 'center', alignItems: 'center' }}>
                        <Typography sx={{ color: 'white' }}>Gender</Typography>
                    </Box>

                    <Box sx={{
                        display: 'flex', flexDirection: 'column', justifyContent: 'center',
                        height: 200,
                        alignItems: 'center'
                    }}>
                        <Box sx={{ height: 150 }}>
                            {
                                employeeData &&
                                <Doughnut data={{
                                    labels: ['Male', 'Female'],
                                    datasets: [
                                        {
                                            label: '# of Votes',
                                            data: [employeeData.totalME, employeeData.totalFE],
                                            backgroundColor: [
                                                '#8CC9F7',
                                                '#FF40FF',

                                            ],
                                            borderColor: 'white',
                                            borderWidth: 1,
                                        },
                                    ],
                                }} options={{
                                    responsive: true,
                                    cutout: 60,
                                    aspectRatio: 4,
                                    maintainAspectRatio: false,
                                    plugins: {
                                        legend: {
                                            position: 'right'
                                            //   display: false,
                                        },
                                    },
                                }} />
                            }

                        </Box>
                    </Box>



                </Paper>

                <Paper elevation={3} sx={{
                    display: 'flex', flexDirection: 'column', padding: 0,
                    pb: 0,
                    "-webkit-justify-content": 'flex-start',
                    height: 250,
                    overflow: 'hidden',
                    width: "32%",
                }}>
                    <Box sx={{ height: 50, background: '#955072', display: 'flex', top: 0, mt: 0, justifyContent: 'center', alignItems: 'center' }}>
                        <Typography sx={{ color: 'white' }}>Division</Typography>
                    </Box>

                    <Box sx={{
                        display: 'flex', flexDirection: 'column', justifyContent: 'center',
                        height: 200,
                        alignItems: 'center'
                    }}>
                        <Box sx={{ height: 200, display: 'flex' }}>
                            {
                                divisionData &&
                                <Doughnut data={{
                                    labels: Object.values(divisionData.taskMap).map(e => e.name),
                                    datasets: [
                                        {
                                            label: '# of Votes',
                                            data: Object.values(divisionData.taskMap).map(e => e.count),
                                            backgroundColor: [
                                                '#F98027',
                                                '#5CCFB0',
                                                '#A8EA53',
                                                '#66C8EC',
                                                '#4D67CB',
                                                '#F04123',

                                            ],
                                            borderColor: 'white',
                                            borderWidth: 1,
                                        },
                                    ],
                                }} options={{
                                    responsive: true,
                                    cutout: 60,
                                    aspectRatio: 4,
                                    maintainAspectRatio: false,
                                    plugins: {
                                        legend: {
                                            position: 'right'
                                            //   display: false,
                                        },
                                    },
                                }} />
                            }

                        </Box>
                    </Box>



                </Paper>

            </Box>


            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
                <Paper elevation={3} sx={{
                    display: 'flex', flexDirection: 'column', padding: 0,
                    pb: 0,
                    "-webkit-justify-content": 'flex-start',
                    height: 300,
                    overflow: 'hidden',
                    width: "66%",
                }}>
                    <Box sx={{ height: 50, background: '#44536A', display: 'flex', top: 0, mt: 0, justifyContent: 'center', alignItems: 'center' }}>
                        <Typography sx={{ color: 'white' }}>Employees By Roles</Typography>
                    </Box>

                    <Box sx={{
                        display: 'flex', flexDirection: 'column', justifyContent: 'center',
                        height: 200,
                        alignItems: 'center',
                        padding: 14
                    }}>
                        {/* <Box sx={{height: 150}}> */}
                        {
                            employeesByRoles &&
                            <Bar options={options} data={{
                                labels: Object.values(employeesByRoles.rolesMap).map(e => e.name),
                                datasets: [
                                    {
                                        label: 'No. of Employees',
                                        data: Object.values(employeesByRoles.rolesMap).map(e => e.count),
                                        backgroundColor: [
                                            '#F98027',
                                            '#5CCFB0',
                                            '#A8EA53',
                                            '#66C8EC',
                                            '#4D67CB',
                                            '#F04123',
                                        ],
                                        borderColor: [
                                            'white',
                                            'white',
                                            'white',
                                            'white',
                                            'white',
                                            'white',
                                        ],
                                    },

                                ],
                            }}
                                plugins={[
                                    {

                                        id: 'legendMarginRight',
                                        afterInit(chart, legend, options) {
                                            console.log('here', chart)
                                            const fitValue = chart.legend.fit;
                                            chart.legend.fit = function fit() {
                                                fitValue.bind(chart.legend)();
                                                return this.width += 100
                                            }
                                        }

                                    }
                                ]}
                            />
                        }
                        {/* </Box> */}



                    </Box>



                </Paper>

                <Paper elevation={3} sx={{
                    display: 'flex', flexDirection: 'column', padding: 0,
                    pb: 0,
                    "-webkit-justify-content": 'flex-start',
                    height: 300,
                    overflow: 'hidden',
                    width: "32%",
                }}>
                    <Box sx={{ height: 50, background: '#44536A', display: 'flex', top: 0, mt: 0, justifyContent: 'center', alignItems: 'center' }}>
                        <Typography sx={{ color: 'white' }}>Attendance</Typography>
                    </Box>

                    <Box sx={{
                        display: 'flex', justifyContent: 'center',
                        height: 200,
                        alignItems: 'center'
                    }}>
                        {
                            attendanceData &&
                            <>
                                <Box sx={{ background: '#F28627', padding: 2, ml: 1, width: 120 }}>
                                    <Typography sx={{ color: 'white', fontSize: '3em', textAlign: 'center' }}>{attendanceData.a || 0}</Typography>
                                    <Typography sx={{ fontWeight: 500, fontSize: '1.2em', color: 'white', textAlign: 'center' }}>Absent</Typography>
                                </Box>
                                <Box sx={{ background: '#62D9B7', padding: 2, ml: 1, width: 120 }}>
                                    <Typography sx={{ color: 'white', fontSize: '3em', textAlign: 'center' }}>{attendanceData.p || 0}</Typography>
                                    <Typography sx={{ fontWeight: 500, fontSize: '1.2em', color: 'white', textAlign: 'center' }}>Present</Typography>
                                </Box>
                                <Box sx={{ background: '#F44024', padding: 2, ml: 1, width: 120 }}>
                                    <Typography sx={{ color: 'white', fontSize: '3em', textAlign: 'center' }}>{attendanceData.l || 0}</Typography>
                                    <Typography sx={{ fontWeight: 500, fontSize: '1.2em', color: 'white', textAlign: 'center' }}>On leave</Typography>
                                </Box>
                            </>
                        }


                    </Box>



                </Paper>



            </Box>


        </Box>

    )
}